import { Action } from '@ngrx/store';

export const TOGGLE_SIDENAV = '[UI] Toggle sidenav';

export class ToggleSidenav implements Action {
  readonly type = TOGGLE_SIDENAV;
}

export type UiActions = ToggleSidenav | any;
